// Implements: F-UIX-018
/**
 * A heading at the level its container asks for (UIX.5 accessibility): one under the heading of
 * the region it sits in, so a state or a list nested in a section never skips or repeats a level
 * of the outline. A switch over real elements, so the outline is readable in the markup.
 */

import type { ReactElement, ReactNode } from "react";

/** The levels a heading under a page's `<h1>` can take. */
export type HeadingLevel = 2 | 3 | 4 | 5 | 6;

export interface HeadingProps {
  readonly level: HeadingLevel;
  readonly id?: string | undefined;
  readonly className?: string | undefined;
  readonly children: ReactNode;
}

export function Heading({ level, id, className, children }: HeadingProps): ReactElement {
  switch (level) {
    case 2:
      return <h2 id={id} className={className}>{children}</h2>;
    case 3:
      return <h3 id={id} className={className}>{children}</h3>;
    case 4:
      return <h4 id={id} className={className}>{children}</h4>;
    case 5:
      return <h5 id={id} className={className}>{children}</h5>;
    case 6:
      return <h6 id={id} className={className}>{children}</h6>;
  }
}
